<div class="gpd-full-page project-contacts-page">
  <div class="gpd-container-header">
    <dx-text-box
      class="gpd-input"
      mode="search"
      (onValueChanged)="grid.instance.searchByText($event.value)"
      [width]="300"
      i18n-placeholder="@@searchContact"
      placeholder="Search contact"
    ></dx-text-box>

    <app-gpd-button
      id="newContactMenuButton"
      type="primary"
      icon="chevron-down"
      i18n-text="@@new"
      text="New"
      iconPosition="after"
      (onClick)="newMenuVisible = !newMenuVisible"
    >
      <dx-popover
        target="#newContactMenuButton"
        [wrapperAttr]="{class:'gpd-popover'}"
        [(visible)]="newMenuVisible"
        [hideOnOutsideClick]="hideNewMenuOnOutsideClick"
        [position]="{ my: 'right top', at: 'right bottom', offset: '0 4' }"
        [showTitle]="false"
        [showCloseButton]="false"
        [width]="220"
        [style.display]="'none'"
      >
        <div *dxTemplate="let d of 'content'">
          <dx-list
            [dataSource]="newMenuItems"
            [hoverStateEnabled]="true"
            [activeStateEnabled]="false"
            [focusStateEnabled]="false"
            selectionMode="none"
            (onItemClick)="onNewMenuClick($event); newMenuVisible = false"
          >
            <div *dxTemplate="let item of 'item'">{{ item.text }}</div>
          </dx-list>
        </div>
      </dx-popover>
    </app-gpd-button>
  </div>
  <dx-data-grid
    #grid
    [dataSource]="contacts"
    (onCellClick)="onCellClick($event)"
    class="gpd-datagrid"
    [allowColumnResizing]="true"
    [columnResizingMode]="'widget'"
    [columnAutoWidth]="false"
    [showBorders]="true"
    [width]="'100%'"
    [rowAlternationEnabled]="false"
    [hoverStateEnabled]="true"
    height="100%"
  >
    <dxo-header-filter [visible]="true"></dxo-header-filter>

    <dxi-column dataField="displayName" i18n-caption="@@name" caption="Name"> </dxi-column>

    <dxi-column
      dataField="role"
      i18n-caption="@@role"
      caption="Role"
      [allowSorting]="true"
      [calculateCellValue]="roleCellValue"
      cellTemplate="roleTemplate"
    >
      <div *dxTemplate="let data of 'roleTemplate'" class="role-cell">
        <span
          class="role-pill role-pill--source"
          *ngFor="let r of sourceRouting(data.data)"
          [title]="r.description"
          (click)="onItemClick(data.data, r)"
        >
          <span class="role-pill__text">{{ r.description }}</span>
        </span>
        <span class="role-pill role-pill--custom" *ngFor="let manual of manualRoles(data.data)" [title]="manual.role">
          <span class="role-pill__text">{{ manual.role }}</span>
          <button
            type="button"
            class="role-pill__x"
            i18n-title="@@delete"
            title="Delete"
            (click)="onRemoveRole(data.data, manual); $event.stopPropagation()"
          >
            ×
          </button>
        </span>
      </div>
    </dxi-column>

    <dxi-column
      dataField="tags"
      i18n-caption="@@tags"
      caption="Tags"
      alignment="left"
      [calculateCellValue]="tagsCellValue"
      cellTemplate="tagsTemplate"
    >
      <div *dxTemplate="let data of 'tagsTemplate'">
        <div class="contact-tag-container">
          <gpd-pill
            *ngFor="let tag of data.data.tags"
            [text]="getTag(tag)"
            backgroundColor="var(--color-secondary)"
            color="var(--color-primary)"
          ></gpd-pill>
        </div>
      </div>
    </dxi-column>
  </dx-data-grid>
</div>

<app-project-add-contact-modal
  [(visible)]="addModalVisible"
  [projectId]="projectId"
  [contactTags]="contactTags"
  (onSaved)="onContactsSaved()"
>
</app-project-add-contact-modal>

<app-project-new-contact-modal
  [(visible)]="newContactModalVisible"
  [projectId]="projectId"
  [type]="newContactType"
  (onSaved)="onContactsSaved()"
>
</app-project-new-contact-modal>

<app-delete-popup
  [visible]="deleteVisible"
  [title]="deleteTitle"
  [message]="deleteMessage"
  (onConfirm)="onDeleteConfirmed()"
  (onAbort)="onDeleteAborted()"
  (visibleChange)="deleteVisible = $event"
>
</app-delete-popup>
